import React from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import LetterboxAppQuickMenu from "./LetterboxAppQuickMenu";
import {Route, Switch, useLocation} from "react-router-dom";
import {getTeamRouterPath, getTeamRouterLink, PATH_APPROVALS_ROOT, PATH_TEAM_ROOT_LINK} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import TeamDashboardSubmenu from "root/Wieldy/ApplicationModules/Team/Sidebar/TeamDashboardSubmenu";
import TeamUsersSubmenu from "root/Wieldy/ApplicationModules/Team/Sidebar/TeamUsersSubmenu";
import {getDefaultMenuForPath} from "root/Wieldy/ApplicationModules/Common/navHelpers";
import ApprovalsAppSubmenu from "root/Wieldy/ApplicationModules/Approvals/Sidebar/ApprovalsAppSubmenu";

const TeamAppSidebar= (props) =>
{
    const { pathname }  = useLocation();

    const menuRoutes = [
        { match: '/details' , defaultMenu: 'details'},
        { match: '/dashboard' , defaultMenu: 'dashboard'},
        { match: '/users' , defaultMenu: 'users', default: true},
    ]

    const getDefaultMenu = () =>{
        return getDefaultMenuForPath( pathname, menuRoutes ) ;
    }

    return (
        <div className="dt-module__sidebar">

            <div className="dt-module__sidebar-header border-bottom">
                <div className="d-none d-md-flex align-items-center justify-content-center">
                    <i className={ "icon " + props.iconName + " icon-2x mr-4"}/>
                    <span className="h2 mb-0 text-muted">{props.title}</span>
                </div>

                <LetterboxAppQuickMenu />
            </div>

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default={getDefaultMenu()}>
                        <AppSidebarMenuItem link={getTeamRouterLink(props.team_id, 'details')} title='Details' iconName='icon-team' name='details'/>
                        <AppSidebarMenuItem link={getTeamRouterLink(props.team_id, 'users')} title='Members' iconName='icon-user' name='users'/>
                        <AppSidebarMenuItem link={getTeamRouterLink(props.team_id, 'dashboard')} title='Dashboard' iconName='icon-dashboard' name='dashboard'/>
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={getTeamRouterPath('dashboard')} render={(thisprops) => <TeamDashboardSubmenu team_id={props.team_id} {...thisprops}/>}/>
                        <Route path={getTeamRouterPath('users')} render={(thisprops) => <TeamUsersSubmenu team_id={props.team_id} {...thisprops}/>}/>
                        <Route path={PATH_TEAM_ROOT_LINK} render={(thisprops) => <TeamUsersSubmenu team_id={props.team_id} {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default TeamAppSidebar;
